import { api } from "@/utils/axios";

export const userService = {
  exitUser(id) {
    return api.post("?c=Port&m=Web_Port&module=Set_user&opt=exit_user", {
      opt_client_name: "weixin",
      id,
    });
  },
  updatePassword(id, now, old) {
    return api.post("?c=Port&m=Web_Port&module=Set_user&opt=update_password", {
      id,
      before_password: old,
      new_password: now,
    });
  },
  updateUser(id, state) {
    return api.post("?c=Port&m=Web_Port&module=Set_user&opt=update_user", {
      id,
      online_state: state,
    });
  },
};
